import JustCurious from "app/publicpages/JustCurious/JustCurious";
import HowTheySeePublic from "app/publicpages/HowTheySeePublic";
import RootGate from "middleware/RootGate";

// GS Current Affairs is not live yet. To switch it on, restore these imports and routes
// import GsCurrentAffairsHub from "app/pages/raajneeti/gsCurrentAffairs";
// import DailyBrief from "app/pages/raajneeti/gsCurrentAffairs/dailyBrief";
// import MonthlyCurrentTracker from "app/pages/raajneeti/gsCurrentAffairs/monthlyCurrentTracker";

const publicRoutes = {
  id: "public",
  children: [
    {
      index: true,
      element: <RootGate />,
    },
    {
      path: "just-curious",
      element: <JustCurious />,
    },
    {
      path: "how-would-they-see-it",
      element: <HowTheySeePublic />,
    },
    // {
    //   path: "gs-current-affairs",
    //   element: <GsCurrentAffairsHub />,
    // },
    // {
    //   path: "gs-current-affairs/daily-brief",
    //   element: <DailyBrief />,
    // },
    // {
    //   path: "gs-current-affairs/monthly-current-tracker",
    //   element: <MonthlyCurrentTracker />,
    // },
  ],
};

export { publicRoutes };